import React from 'react';
import { Navigate } from 'react-router-dom';

/**
 * Protected Route Guard
 * Redirects to login if user is not authenticated
 */
export const ProtectedRoute = ({ children, isLoggedIn }) => {
  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

/**
 * Guest Route Guard
 * Redirects to home if user is already logged in
 * Used for auth pages (login, register, etc.)
 */
export const GuestRoute = ({ children, isLoggedIn }) => {
  if (isLoggedIn) {
    return <Navigate to="/" replace />;
  }
  return children;
};


